/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-boxsizing-cssanimations-csscalc-cssgradients-csstransforms3d-csstransformslevel2-csstransitions-preserve3d-supports-svg-svgasimg-svgclippaths-svgfilters-touchevents-setclasses !*/
 ! function (e, t, n) {
	function r(e, t) {
		return typeof e === t
	}

	function o() {
		var e, t, n, o, s, i, a;
		for (var l in C)
			if (C.hasOwnProperty(l)) {
				if (e = [], t = C[l], t.name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length))
					for (n = 0; n < t.options.aliases.length; n++) e.push(t.options.aliases[n].toLowerCase());
				for (o = r(t.fn, "function") ? t.fn() : t.fn, s = 0; s < e.length; s++) i = e[s], a = i.split("."), 1 === a.length ? Modernizr[a[0]] = o : (!Modernizr[a[0]] || Modernizr[a[0]] instanceof Boolean || (Modernizr[a[0]] = new Boolean(Modernizr[a[0]])), Modernizr[a[0]][a[1]] = o), S.push((o ? "" : "no-") + a.join("-"))
			}
	}

	function s(e) {
		var t = b.className,
			n = Modernizr._config.classPrefix || "";
		if (E && (t = t.baseVal), Modernizr._config.enableJSClass) {
			var r = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
			t = t.replace(r, "$1" + n + "js$2")
		}
		Modernizr._config.enableClasses && (t += " " + n + e.join(" " + n), E ? b.className.baseVal = t : b.className = t)
	}

	function i() {
		return "function" != typeof t.createElement ? t.createElement(arguments[0]) : E ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments)
	}

	function a(e, t) {
		if ("object" == typeof e)
			for (var n in e) N(e, n) && a(n, e[n]);
		else {
			e = e.toLowerCase();
			var r = e.split("."),
				o = Modernizr[r[0]];
			if (2 == r.length && (o = o[r[1]]), "undefined" != typeof o) return Modernizr;
			t = "function" == typeof t ? t() : t, 1 == r.length ? Modernizr[r[0]] = t : (!Modernizr[r[0]] || Modernizr[r[0]] instanceof Boolean || (Modernizr[r[0]] = new Boolean(Modernizr[r[0]])), Modernizr[r[0]][r[1]] = t), s([(t && 0 != t ? "" : "no-") + r.join("-")]), Modernizr._trigger(e, t)
		}
		return Modernizr
	}

	function l() {
		var e = t.body;
		return e || (e = i(E ? "svg" : "body"), e.fake = !0), e
	}

	function u(e, n, r, o) {
		var s, a, u, f, c = "modernizr",
			d = i("div"),
			p = l();
		if (parseInt(r, 10))
			for (; r--;) u = i("div"), u.id = o ? o[r] : c + (r + 1), d.appendChild(u);
		return s = i("style"), s.type = "text/css", s.id = "s" + c, (p.fake ? p : d).appendChild(s), p.appendChild(d), s.styleSheet ? s.styleSheet.cssText = e : s.appendChild(t.createTextNode(e)), d.id = c, p.fake && (p.style.background = "", p.style.overflow = "hidden", f = b.style.overflow, b.style.overflow = "hidden", b.appendChild(p)), a = n(d, e), p.fake ? (p.parentNode.removeChild(p), b.style.overflow = f, b.offsetHeight) : d.parentNode.removeChild(d), !!a
	}

	function f(e, t) {
		return !!~("" + e).indexOf(t)
	}

	function c(e) {
		return e.replace(/([a-z])-([a-z])/g, function (e, t, n) {
			return t + n.toUpperCase()
		}).replace(/^-/, "")
	}

	function d(e, t) {
		return function () {
			return e.apply(t, arguments)
		}
	}

	function p(e, t, n) {
		var o;
		for (var s in e)
			if (e[s] in t) return n === !1 ? e[s] : (o = t[e[s]], r(o, "function") ? d(o, n || t) : o);
		return !1
	}

	function m(e) {
		return e.replace(/([A-Z])/g, function (e, t) {
			return "-" + t.toLowerCase()
		}).replace(/^ms-/, "-ms-")
	}

	function g(t, n, r) {
		var o;
		if ("getComputedStyle" in e) {
			o = getComputedStyle.call(e, t, n);
			var s = e.console;
			if (null !== o) r && (o = o.getPropertyValue(r));
			else if (s) {
				var i = s.error ? "error" : "log";
				s[i].call(s, "getComputedStyle returning null, its possible modernizr test results are inaccurate")
			}
		} else o = !n && t.currentStyle && t.currentStyle[r];
		return o
	}

	function h(t, r) {
		var o = t.length;
		if ("CSS" in e && "supports" in e.CSS) {
			for (; o--;)
				if (e.CSS.supports(m(t[o]), r)) return !0;
			return !1
		}
		if ("CSSSupportsRule" in e) {
			for (var s = []; o--;) s.push("(" + m(t[o]) + ":" + r + ")");
			return s = s.join(" or "), u("@supports (" + s + ") { #modernizr { position: absolute; } }", function (e) {
				return "absolute" == g(e, null, "position")
			})
		}
		return n
	}

	function v(e, t, o, s) {
		function a() {
			u && (delete R.style, delete R.modElem)
		}
		if (s = r(s, "undefined") ? !1 : s, !r(o, "undefined")) {
			var l = h(e, o);
			if (!r(l, "undefined")) return l
		}
		for (var u, d, p, m, g, v = ["modernizr", "tspan", "samp"]; !R.style && v.length;) u = !0, R.modElem = i(v.shift()), R.style = R.modElem.style;
		for (p = e.length, d = 0; p > d; d++)
			if (m = e[d], g = R.style[m], f(m, "-") && (m = c(m)), R.style[m] !== n) {
				if (s || r(o, "undefined")) return a(), "pfx" == t ? m : !0;
				try {
					R.style[m] = o
				} catch (y) {}
				if (R.style[m] != g) return a(), "pfx" == t ? m : !0
			}
		return a(), !1
	}

	function y(e, t, n, o, s) {
		var i = e.charAt(0).toUpperCase() + e.slice(1),
			a = (e + " " + V.join(i + " ") + i).split(" ");
		return r(t, "string") || r(t, "undefined") ? v(a, t, o, s) : (a = (e + " " + A.join(i + " ") + i).split(" "), p(a, t, n))
	}

	function w(e, t, r) {
		return y(e, n, n, t, r)
	}
	var S = [],
		C = [],
		T = {
			_version: "3.6.0",
			_config: {
				classPrefix: "",
				enableClasses: !0,
				enableJSClass: !0,
				usePrefixes: !0
			},
			_q: [],
			on: function (e, t) {
				var n = this;
				setTimeout(function () {
					t(n[e])
				}, 0)
			},
			addTest: function (e, t, n) {
				C.push({
					name: e,
					fn: t,
					options: n
				})
			},
			addAsyncTest: function (e) {
				C.push({
					name: null,
					fn: e
				})
			}
		},
		Modernizr = function () {};
	Modernizr.prototype = T, Modernizr = new Modernizr, Modernizr.addTest("svg", !!t.createElementNS && !!t.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect);
	var _ = "CSS" in e && "supports" in e.CSS,
		x = "supportsCSS" in e;
	Modernizr.addTest("supports", _ || x), Modernizr.addTest("svgfilters", function () {
		var t = !1;
		try {
			t = "SVGFEColorMatrixElement" in e && 2 == SVGFEColorMatrixElement.SVG_FECOLORMATRIX_TYPE_SATURATE
		} catch (n) {}
		return t
	});
	var b = t.documentElement,
		E = "svg" === b.nodeName.toLowerCase(),
		P = T._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
	T._prefixes = P, Modernizr.addTest("csscalc", function () {
		var e = "width:",
			t = "calc(10px);",
			n = i("a");
		return n.style.cssText = e + P.join(t + e), !!n.style.length
	}), Modernizr.addTest("cssgradients", function () {
		for (var e, t = "background-image:", n = "gradient(linear,left top,right bottom,from(#9f9),to(white));", r = "", o = 0, s = P.length - 1; s > o; o++) e = 0 === o ? "to " : "", r += t + P[o] + "linear-gradient(" + e + "left top, #9f9, white);";
		Modernizr._config.usePrefixes && (r += t + "-webkit-" + n);
		var a = i("a"),
			l = a.style;
		return l.cssText = r, ("" + l.backgroundImage).indexOf("gradient") > -1
	}), Modernizr.addTest("preserve3d", function () {
		var t, n, r = e.CSS,
			o = !1;
		return r && r.supports && r.supports("(transform-style: preserve-3d)") ? !0 : (t = i("a"), n = i("a"), t.style.cssText = "display: block; transform-style: preserve-3d; transform-origin: right; transform: rotateY(40deg);", n.style.cssText = "display: block; width: 9px; height: 1px; background: #000; transform-origin: right; transform: rotateY(40deg);", t.appendChild(n), b.appendChild(t), o = n.getBoundingClientRect(), b.removeChild(t), o = o.width && o.width < 4)
	});
	var z = {}.toString;
	Modernizr.addTest("svgclippaths", function () {
		return !!t.createElementNS && /SVGClipPath/.test(z.call(t.createElementNS("http://www.w3.org/2000/svg", "clipPath")))
	});
	var N;
	! function () {
		var e = {}.hasOwnProperty;
		N = r(e, "undefined") || r(e.call, "undefined") ? function (e, t) {
			return t in e && r(e.constructor.prototype[t], "undefined")
		} : function (t, n) {
			return e.call(t, n)
		}
	}(), T._l = {}, T.on = function (e, t) {
		this._l[e] || (this._l[e] = []), this._l[e].push(t), Modernizr.hasOwnProperty(e) && setTimeout(function () {
			Modernizr._trigger(e, Modernizr[e])
		}, 0)
	}, T._trigger = function (e, t) {
		if (this._l[e]) {
			var n = this._l[e];
			setTimeout(function () {
				var e, r;
				for (e = 0; e < n.length; e++)(r = n[e])(t)
			}, 0), delete this._l[e]
		}
	}, Modernizr._q.push(function () {
		T.addTest = a
	}), Modernizr.addTest("svgasimg", t.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Image", "1.1"));
	var k = T.testStyles = u;
	Modernizr.addTest("touchevents", function () {
		var n;
		if ("ontouchstart" in e || e.DocumentTouch && t instanceof DocumentTouch) n = !0;
		else {
			var r = ["@media (", P.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");
			k(r, function (e) {
				n = 9 === e.offsetTop
			})
		}
		return n
	});
	var j = "Moz O ms Webkit",
		V = T._config.usePrefixes ? j.split(" ") : [];
	T._cssomPrefixes = V;
	var A = T._config.usePrefixes ? j.toLowerCase().split(" ") : [];
	T._domPrefixes = A;
	var O = {
		elem: i("modernizr")
	};
	Modernizr._q.push(function () {
		delete O.elem
	});
	var R = {
		style: O.elem.style
	};
	Modernizr._q.unshift(function () {
		delete R.style
	}), T.testAllProps = y, T.testAllProps = w, Modernizr.addTest("cssanimations", w("animationName", "a", !0)), Modernizr.addTest("boxsizing", w("boxSizing", "border-box", !0) && (t.documentMode === n || t.documentMode > 7)), Modernizr.addTest("csstransforms3d", function () {
		return !!w("perspective", "1px", !0)
	}), Modernizr.addTest("csstransformslevel2", function () {
		return w("translate", "45px", !0)
	}), Modernizr.addTest("csstransitions", w("transition", "all", !0)), o(), s(S), delete T.addTest, delete T.addAsyncTest;
	for (var L = 0; L < Modernizr._q.length; L++) Modernizr._q[L]();
	e.Modernizr = Modernizr
}(window, document);